// FileProcessed.js


import './styles.css';
import React, { useState, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import { Link, json, useParams  } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import JsonViewer from 'react-json-prettify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import dropdownTogle from './images/dropdownIcon.svg';
import { googlecode } from 'react-json-prettify/dist/themes';

const FileProcessedScore = ({ FileProcessedScore = {} }) => {
  const { itemId } = useParams();
  const [jsonFormData, setJsonFormData] = useState();
  const [jsonData, setJsonData] = useState(); 
  const [expandedCards, setExpandedCards] = useState({});
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fileName = searchParams.get('fileName');
  const type = searchParams.get('type');

  useEffect(() => 
    {
    //verificar se o usuário está logado
    if (localStorage.getItem("user") === null) {
      window.location.href = "/";

    }
    else {

      const data = JSON.parse(localStorage.getItem("user"));
    }
  })
  
  useEffect(() => {
    // Verificar se o usuário está logado
    if (localStorage.getItem("user") === null) {
      window.location.href = "/";
    }
    else {
      const data = JSON.parse(localStorage.getItem("user"));
    }
  }, []);
  
  useEffect(() => {
    const formJson = async (itemID) => {
      try {
        const formData = new FormData();
        formData.append('ID', itemID);
  
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + '/api/ReturnData',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f',
            }
          }
        );
  
        var jsonUnformatted = response.data.jsonData;
        const jsonFormatted = JSON.parse(jsonUnformatted);
        setJsonFormData(jsonFormatted);
  
        jsonUnformatted = jsonUnformatted.replace(/\\n/g, '').replace(/\\r/g, '').replace(/\\"""/g, '').replace(/\\/g, '');
        const jsonFormattedData = JSON.parse(jsonUnformatted);
        // setJsonData(JSON.stringify(jsonFormattedData, undefined, 2))
        setJsonData((jsonFormattedData))
  
      } catch (error) {
        console.error(error);
      }
    };
  
    formJson(itemId);
  }, [itemId]);

  const getScoreColor = (score) => {
    if (score == 100) {
      return 'green';
    } else if (score == 0) {
      return 'red';
    } else {
      return '#CCE600';
    }
  };
  
  const renderTypeIcon = (type) => {
    switch (type) {
      case 'string':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-file-text" viewBox="0 0 16 16">
            <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/>
            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"/>
          </svg>
        );
      case 'array':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-card-list" viewBox="0 0 16 16">
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"/>
            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8m0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
          </svg>
        );
      case 'date':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-calendar-date" viewBox="0 0 16 16">
            <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23"/>
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
          </svg>
        );
      case 'numeric':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-sort-numeric-down-alt" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98"/>
            <path d="M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
          </svg>
        );
      case '':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-file-text" viewBox="0 0 16 16">
          <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/>
          <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"/>
        </svg>
      );
      default:
        return null;
    }
  };

  const renderSimpleCard = (item) => (
      <div className='row card-body'>
        <div className='col-lg-2 d-flex align-items-center justify-content-center'>
          {renderTypeIcon(item.type)}
        </div>
        <div className='col-lg-10 d-flex flex-column justify-content-center'>
          <h6 >Campo: <b>{item.name}</b></h6>
          <h6 >Score: <span style={{ color: getScoreColor(item.score) }}>{item.score}</span></h6>
          <h5 >Valor: <b>{item.value}</b></h5>
          <h6 >Referência: <b>{item.nomeEncontradoIA}</b></h6>
        </div>
      </div>
  );

  const renderArrayItems = (items) => {
    return items.map((item, key) => {
      if (item.item) {
        return (
          // Caso seja array
          <div key={key}>
              {item.item.map((subItem, subIndex) => (
                <div className='card mb-3' key={subIndex}>
                  {renderSimpleCard(subItem)}
                </div>
              ))}
              <hr/>
          </div>
        );
      } else {
        return (
          <div className="card mb-3" key={key}>
             {renderSimpleCard(item)}
          </div>
        );
      }
    });
  };


  const toggleCardExpansion = (subKey) => {
    setExpandedCards((Cards) => ({
      ...Cards,
      [subKey]: !Cards[subKey],
    }));
  };

  const renderObjectInputs = (obj) => {
    return Object.entries(obj).map(([subKey, subValue]) => {

      // Array Card
      if (subValue.type === 'array' && subValue.fields) {
        const isExpanded = expandedCards[subKey];
        return (
          <div key={subKey} className='col-lg-4 mb-3'>

            {/* Alterna os icones de dropdown */}
            <div className='card shadow' onClick={() => toggleCardExpansion(subKey)}>

              <button className='btn' type='button' data-bs-toggle='collapse' data-bs-target={`#collapse-${subKey}`} aria-expanded='true' aria-controls={`collapse-${subKey}`}   style={{minHeight:"200px"}}>
                <div className='row card-body'>
                  <div className='col-lg-2 d-flex align-items-center justify-content-center'>
                      {renderTypeIcon(subValue.type)}
                  </div>
                  <div className='col-lg-10 d-flex flex-column align-items-start justify-content-center'>
                    <h4 className='card-title'>
                      <span className='cardTitleOverflow' id='cardTitle'>{subValue.name}</span>
                      <span className='dropdown-toggle-split'>
                        {isExpanded ? (
                            <img src={dropdownTogle} alt="dropdownToggle" className='dropdownIconRotate180'/>
                          ) : (
                            <img src={dropdownTogle} alt="dropdownToggle" className='dropdownIconRotate0'/>
                          )}
                      </span>
                    </h4>
                  </div>
                </div>
                <div id={`collapse-${subKey}`} className='collapse' aria-labelledby={`heading-${subKey}`} data-bs-parent='#accordion'>
                  <div className='card-body'>
                    {renderArrayItems(subValue.fields)}
                  </div>
                </div>
              </button>
            </div>
          </div>
        );
      } else {
        return (
          <div key={subKey} className='col-lg-4 mb-3'>
            <div className='card cardSize shadow'>
              {renderSimpleCard(subValue)}
            </div>
          </div>
        );
      }
    });
  };

  return (
    <div>
      <div className="container-fluid p-0">
        <HeaderLogged />
        <div className="row showContentMargin">
          <div className="col-auto col-lg-auto col-xxl-2" id='divSidebar'>
            <Sidebar></Sidebar>
          </div>
          <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
            <h4 className='text-center'>{fileName}</h4>
            <h4 className='text-center mb-4'>{type}</h4>
            {jsonData && Object.entries(jsonFormData).map(([key, value], index) => (
              <div key={key} className='row'>
                {Object.entries(value).map(([subKey, subValue]) => (
                  renderObjectInputs(subValue, subKey)
                ))}
              </div>
            ))}
                  <div className="row">
              <div className="col-lg-12 text-center mt-4">
                <button className="btn btn-success btn-lg" type="button" data-bs-toggle="collapse" data-bs-target="#json" aria-expanded="false">
                  Json
                </button>
                <a type="submit" href='/fileupload' className="btn btn-success btn-lg ms-3">
                  Novo Processamento
                </a>
              </div>
              <div className='d-flex align-items-center justify-content-center'>
                {jsonData && (
                    <div className='col-md-8 mt-4'>
                      <div className='card'>
                        <div className="collapse" id="json">
                        <JsonViewer
                          json={jsonData}
                          theme={googlecode} //colorBrewer //googlecode //monoBlue
                          padding={4}
                          indent={0}
                        />

                          {/* <textarea className="mt-4" value={jsonData} readOnly rows={13} cols={50} /> */}
                        </div>
                      </div>    
                    </div>
                  )}
              </div>
                
            </div>
          </main>
        </div>
      </div>
    </div>
  );
  };

export default FileProcessedScore;